import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { ArrowRight, Sparkles } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';
import logo from '@/assets/gaius-logo.webp';

export const WelcomeDialog = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { language } = useLanguage();
  const fr = language === 'fr';

  useEffect(() => {
    const hash = window.location.hash;
    if (hash && hash.includes('type=signup')) {
      setOpen(true);
      window.history.replaceState(null, '', window.location.pathname);
    }
  }, []);

  const handleDiscover = () => {
    setOpen(false);
    navigate(fr ? '/formations' : '/training');
  };

  const handleClose = () => {
    setOpen(false);
    // Navigate to last visited page or dashboard
    const lastPage = localStorage.getItem('gaius-last-page');
    if (lastPage && lastPage !== '/auth' && lastPage !== '/connexion') {
      localStorage.removeItem('gaius-last-page');
      navigate(lastPage);
    } else {
      navigate(fr ? '/espace-client' : '/dashboard');
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) handleClose(); }}>
      <DialogContent className="sm:max-w-md text-center p-8 gap-6">
        <div className="flex flex-col items-center space-y-6">
          <img src={logo} alt="Gaius" className="h-16" />
          
          <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center">
            <Sparkles className="w-7 h-7 text-primary" />
          </div>

          <div className="space-y-2">
            <h2 className="text-2xl font-bold text-foreground">
              {fr ? 'Votre compte a été créé' : 'Your account has been created'}
            </h2>
            <p className="text-xl text-primary font-semibold">
              {fr ? 'Bienvenue sur Gaius !' : 'Welcome to Gaius!'}
            </p>
          </div>

          <p className="text-muted-foreground text-sm leading-relaxed">
            {fr 
              ? 'Votre adresse email a été vérifiée avec succès. Vous pouvez maintenant accéder à toutes nos ressources et formations.'
              : 'Your email has been verified successfully. You can now access all our resources and training programs.'}
          </p>

          <div className="flex flex-col w-full gap-3 pt-2">
            <Button 
              onClick={handleDiscover} 
              size="lg" 
              className="w-full text-base h-12"
            >
              {fr ? 'Découvrez comment vous former à l\'IA' : 'Discover our AI training programs'}
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
            <Button 
              variant="ghost" 
              onClick={handleClose}
              className="text-sm text-muted-foreground"
            >
              {fr ? 'Accéder à mon espace Gaius' : 'Go to my Gaius space'}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
